export default "__VITE_ASSET__DASC5pFS__"